import {IKuPiper} from '@/middleware/types';
import DocBottomBar from '@/tocPages/components/DocBottomBar';

export const initSlots = (kuPiper: IKuPiper, options: any) => {
    kuPiper.registerSlots({
        options,
        slots: [
            // ----文档顶栏隐藏项----
            // 演示模式按钮
            {
                type: 'Normal',
                action: 'Delete',
                slot: {
                    scope: kuPiper.slotScopeMap.DocumentHeader,
                    position: kuPiper.slotPositionMap.DocumentHeader.DemoModeButton,
                },
            },
            // 权限按钮
            {
                type: 'Normal',
                action: 'Delete',
                slot: {
                    scope: kuPiper.slotScopeMap.DocumentHeader,
                    position: kuPiper.slotPositionMap.DocumentHeader.PermissionBtn,
                },
            },
            // 星标按钮
            {
                type: 'Normal',
                action: 'Delete',
                slot: {
                    scope: kuPiper.slotScopeMap.DocumentHeader,
                    position: kuPiper.slotPositionMap.DocumentHeader.StarBtn,
                },
            },
            // 更多菜单按钮
            {
                type: 'Normal',
                action: 'Delete',
                slot: {
                    scope: kuPiper.slotScopeMap.DocumentHeader,
                    position: kuPiper.slotPositionMap.DocumentHeader.MoreMenuIcon,
                },
            },
            // 只读权限-权限申请按钮
            {
                type: 'Normal',
                action: 'Delete',
                slot: {
                    scope: kuPiper.slotScopeMap.DocumentHeader,
                    position: kuPiper.slotPositionMap.DocumentHeader.ReadOnlyApplyButton,
                },
            },

            // ----文档底部隐藏项----
            // 文档页-点赞和投币
            {
                type: 'Normal',
                action: 'Delete',
                slot: {
                    scope: kuPiper.slotScopeMap.DocumentEditor,
                    position: kuPiper.slotPositionMap.DocumentEditor.LikeAndCoinBtn,
                },
            },
            {
                type: 'Normal',
                action: 'Replace',
                slot: { // 指定位置
                    scope: kuPiper.slotScopeMap.DocumentEditor,
                    position: kuPiper.slotPositionMap.DocumentEditor.BottomBar,
                },
                Comp: () => <DocBottomBar />,
                active: true,
            },
        ],
    });
};
